export const MAX_SIZE_FILE_CONTACTS_IN_BYTES = 10 * 1024 * 1024; // 10MB

export const CONTACT_FILE_PROCESSOR_STEPS = {
  UPLOAD: "UPLOAD",
  COUNTRY_SELECT: "COUNTRY_SELECT",
  DUPLICATES_DECISION: "DUPLICATES_DECISION",
  REVIEW: "REVIEW",
};

export const CONTACT_FILE_PROCESSOR_TABS = {
  VALID: "VALID",
  INVALID: "INVALID",
};
